<template>
  <div>
    <form class="columns is-multiline is-padding">
      <div class="column is-12">
        <r-label
          :label="'Nom de la société'"
          :red-check="true"
          :value="promoteur.company_name"></r-label>
        <v-input
          id="company_name"
          name="company_name"
          @input="val => promoteur.company_name = val"
          :model="promoteur.company_name"
          data-vv-as="Nom de la société"
          v-validate="'min:2'"
          :errors-bag="errors"
          data-vv-value-path="val">
        </v-input>
      </div>
      <div class="column is-12">
        <r-label
          :label="'Nom du représentant'"
          :value="promoteur.rep_last_name"
          :red-check="true"></r-label>
        <v-input
          id="last_name"
          name="last_name"
          @input="val => promoteur.rep_last_name = val"
          :model="promoteur.rep_last_name"
          data-vv-as="Nom"
          v-validate="'min:2'"
          :errors-bag="errors"
          data-vv-value-path="val">
        </v-input>
      </div>
      <div class="column is-12">
        <r-label
          :label="'Prénom du représentant'"
          :value="promoteur.rep_first_name"
          :red-check="true"></r-label>
        <v-input
          id="first_name"
          name="first_name"
          @input="val => promoteur.rep_first_name = val"
          :model="promoteur.rep_first_name"
          v-validate="'min:2'"
          :errors-bag="errors"
          data-vv-value-path="val"
          data-vv-as="Prénom">
        </v-input>
      </div>
      <div class="column is-12">
        <r-label
          :label="'Adresse mail'"
          :value="promoteur.rep_email"
          :red-check="true"></r-label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-static is-border is-square">
              <span class="icon"><i class="fas fa-paper-plane"></i></span>
            </a>
          </div>
          <div class="control is-expanded">
            <v-input
              id="email"
              name="email"
              @input="val => promoteur.rep_email = val"
              :model="promoteur.rep_email"
              v-validate="'email'"
              :errors-bag="errors"
              data-vv-value-path="val"
              data-vv-as="Email">
            </v-input>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <phone-input
          :value="promoteur.rep_phone"
          :placeholder="'Numéro de téléphone'"
          :required="true"
          @input="val => promoteur.rep_phone = val">
          <r-label
            slot="label"
            :label="'Téléphone'"
            :value="promoteur.rep_phone"
            :red-check="true"
            :truncate="false">
            <span
              class="is-padding-left-xsmall"
              v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
              <i class="fal fa-info-circle"></i>
            </span>
          </r-label>
        </phone-input>
      </div>
      <div class="column is-12">
        <address-input
          :source="address"
          :red-check="true"
          :is-required="true"
          @update="updateAddress">
        </address-input>
      </div>
    </form>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  name: 'PromoteurForm',
  props: {
    source: {
      type: Object,
      required: true
    },
    paramsQuickview: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      promoteur: {},
      address: {}
    }
  },
  created () {
    this.promoteur = cloneDeep(this.source) || {}
    if (this.promoteur.rep_address) {
      this.address = Object.assign({}, this.promoteur.rep_address)
    }
  },
  methods: {
    updateAddress (address) {
      this.$set(this, 'address', address)
      this.promoteur.rep_address = this.address
    },
    submitQuickview () {
      if (this.promoteur.rep_address) {
        if (this.promoteur.rep_address.city === '' || this.promoteur.rep_address.line1 === '' || this.promoteur.rep_address.country === '' || this.promoteur.rep_address.zip_code === '') this.promoteur.rep_address = {}
      }
      if (this.promoteur.company_name === '') this.promoteur.company_name = null
      if (this.promoteur.rep_first_name === '') this.promoteur.rep_first_name = null
      if (this.promoteur.rep_last_name === '') this.promoteur.rep_last_name = null
      if (this.promoteur.rep_phone === '') this.promoteur.rep_phone = null
      if (this.promoteur.rep_email === '') this.promoteur.rep_email = null
      if (!this.promoteur.company_name || !this.promoteur.rep_first_name || !this.promoteur.rep_last_name || !this.promoteur.rep_phone || !this.promoteur.rep_email || !this.promoteur.rep_address || !this.promoteur.rep_address.line1) {
        return this.$toasted.global.danger('Information(s) obligatoire(s) manquante')
      }
      this.$emit('submitQuickview', { promoteur: this.promoteur })
    }
  }
}
</script>
